/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class SlaSummary {
  public slaStartDate: Date | string;
  public slaHoursUntilDate: string = undefined;
  public slaHoursUntilDateFormatted: string = undefined;
}
